import React from "react";
import { Link } from "react-router-dom";

function NotFoundPage() {
  return (
    <div className="grid place-items-center  dark:bg-white h-screen w-screen">
      <h2>Page Not found, please login.</h2>
      <button className="bg-gradient-to-b from-[#BE2117] to-[#09062C] rounded-[20px] p-4  px-11 text-white mt-5 w-[240px]">
        {" "}
        <Link to="/"> Login</Link>
      </button>
    </div>
  );
}

export default NotFoundPage;
